import useSWR from 'swr';
import client from 'utils/client';

const fetcher = (...args) => client.get(...args).then(res => res.data);

/**
 * Fetches the Search Information for a given Query.
 * @param params {Object} - Object containing the Query and the ElasticSearch Queries that should be
 *   passed to the URL Parameters.
 * @returns {{isLoading: boolean, isError: any, data: AxiosResponse<any>}}
 */
function useSearchData(params) {
  const urlParams = new URLSearchParams(params).toString();

  const { data, error } = useSWR(`/api/search/?${urlParams}`, fetcher, {
    revalidateOnFocus: false,
    revalidateOnReconnect: false
  });

  return {
    data,
    isLoading: !error && !data,
    isError: error
  };
}

export default useSearchData;
